export default __webpack_public_path__ + "static/media/driving-sustainability-in-the-middle-east.deafb1e5.jpg";